'use client';
import { useTranslation } from '@/i18n/LanguageProvider';
import Link from '@/components/LocaleLink';
import { Smartphone, Mail, Trash2, AlertTriangle, HelpCircle } from 'lucide-react';

export default function DeleteAccountPage() {
  const { t } = useTranslation();
  return (
    <div>
      <section className="bg-gradient-to-br from-red-600 to-red-500 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Trash2 className="w-16 h-16 mx-auto mb-4 opacity-80" />
          <h1 className="text-4xl font-bold mb-4">{t('deleteAccount.title')}</h1>
          <p className="text-white/90">{t('deleteAccount.subtitle')}</p>
        </div>
      </section>
      <section className="py-16 bg-white dark:bg-gray-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-gray-50 dark:bg-gray-900 rounded-2xl p-8">
              <div className="w-14 h-14 bg-primary-100 dark:bg-gray-800 rounded-xl flex items-center justify-center mb-6"><Smartphone className="w-7 h-7 text-primary" /></div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('deleteAccount.method1Title')}</h2>
              <ol className="list-decimal pl-5 text-gray-600 dark:text-gray-300 space-y-2">
                <li>{t('deleteAccount.method1Steps.0')}</li>
                <li>{t('deleteAccount.method1Steps.1')}</li>
                <li>{t('deleteAccount.method1Steps.2')}</li>
                <li>{t('deleteAccount.method1Steps.3')}</li>
                <li>{t('deleteAccount.method1Steps.4')}</li>
              </ol>
              <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">{t('deleteAccount.method1Note')}</p>
            </div>
            <div className="bg-gray-50 dark:bg-gray-900 rounded-2xl p-8">
              <div className="w-14 h-14 bg-secondary-100 dark:bg-gray-800 rounded-xl flex items-center justify-center mb-6"><Mail className="w-7 h-7 text-secondary" /></div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('deleteAccount.method2Title')}</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-4">{t('deleteAccount.method2Text')} <a href="mailto:privacidad@iterogo.com" className="text-primary hover:underline font-semibold">privacidad@iterogo.com</a></p>
              <p className="text-gray-600 dark:text-gray-300 mb-2 font-semibold">{t('deleteAccount.method2Include')}</p>
              <ul className="list-disc pl-5 text-gray-600 dark:text-gray-300 space-y-2">
                <li>{t('deleteAccount.method2a')}</li>
                <li>{t('deleteAccount.method2b')}</li>
                <li>{t('deleteAccount.method2c')}</li>
              </ul>
              <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">{t('deleteAccount.method2Note')}</p>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="border border-red-200 rounded-2xl p-6">
              <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-4 flex items-center gap-2"><Trash2 className="w-5 h-5 text-red-500" />{t('deleteAccount.whatDeletedTitle')}</h3>
              <ul className="text-gray-600 dark:text-gray-300 space-y-2">
                {[0,1,2,3,4].map(i=><li key={i}>• {t(`deleteAccount.deletedItems.${i}`)}</li>)}
              </ul>
            </div>
            <div className="border border-gray-200 dark:border-gray-700 rounded-2xl p-6">
              <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-4">{t('deleteAccount.whatKeptTitle')}</h3>
              <ul className="text-gray-600 dark:text-gray-300 space-y-2">
                {[0,1,2,3].map(i=><li key={i}>• {t(`deleteAccount.keptItems.${i}`)}</li>)}
              </ul>
            </div>
          </div>
          <div className="bg-yellow-50 dark:bg-gray-800 border border-yellow-200 rounded-2xl p-6 mb-12">
            <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-4 flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-yellow-600" />{t('deleteAccount.importantTitle')}</h3>
            <ul className="text-gray-600 dark:text-gray-300 space-y-2">
              {[0,1,2].map(i=><li key={i}>• {t(`deleteAccount.importantItems.${i}`)}</li>)}
            </ul>
          </div>
          <div className="bg-primary-50 dark:bg-gray-800 rounded-2xl p-8 text-center">
            <HelpCircle className="w-10 h-10 text-primary mx-auto mb-4" />
            <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-2">{t('deleteAccount.helpTitle')}</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-6">{t('deleteAccount.helpText')}</p>
            <Link href="/contact" className="btn-primary">{t('footer.contact')}</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
